import { Model } from "@vuex-orm/core";

export default class UserArticle extends Model {
    static entity = "userArticles";
    static fields() {
        return {
            id: this.attr(null),
            number: this.attr(null),
            designation: this.attr(null),
            description: this.attr(null),
            article_group: this.attr(null),
            price: this.attr(null),
            discount: this.attr(null),
        };
    }

    get art_no() {
        return this.number;
    }

    get name() {
        return this.designation;
    }

    getDetail() {
        return this.description;
    }

    getDocument() {
        return "";
    }
}
